/**
 * @description Create a download link, auto-click it to save the file and finally remove the created link.
 * @param blobData - The blob data to be saved.
 * @param fileName - The file name to save the blob data as.
 *
 * @example
 * yourFetchFunction().then((response) => createDownloadLink(response, 'your-file-name.pdf'));
 */
export const createDownloadLink = (blobData: Blob | BlobPart, fileName: string) => {
  const blobURL = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement('a');
  link.href = blobURL;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
